import { render } from "./VvHeader.vue?vue&type=template&id=561e178c&scoped=true"
import script from "./VvHeader.vue?vue&type=script&lang=js"
export * from "./VvHeader.vue?vue&type=script&lang=js"

import "./VvHeader.vue?vue&type=style&index=0&id=561e178c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561e178c"]])

export default __exports__